import { Breadcrumbs } from "@sembark-travel/ui-router"
import { useXHR } from "@sembark-travel/xhr"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { Box, Container } from "@sembark-travel/ui-base"
import {
	NewWhatsAppSimulatorIntegrationForm,
	TIntegration,
} from "../../../../Integrations"
import { showSnackbar } from "@sembark-travel/ui-snackbar"

export default function NewWhatsAppSimulatorIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()

	return (
		<>
			<Helmet>
				<title>New WhatsApp Simulator Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New WhatsApp Simulator Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[generatePath("/integrations/new"), "New"],
					["", "WhatsApp Simulator Integration"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewWhatsAppSimulatorIntegrationForm
								initialValues={{
									name: "WhatsApp Simulator",
									description:
										"Internal testing for customer communication via WhatsApp Integrations",
								}}
								onSubmit={async (values) => {
									const integration = await xhr
										.post<{ data: TIntegration }>("integrations", {
											...values,
										})
										.then((resp) => resp.data.data)
									showSnackbar("Integration created successfully.")
									navigate("/integrations/:integrationId", {
										params: {
											integrationId: String(integration.uid),
										},
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/org/integrations", { replace: true })
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
